import { buildGoalMetric } from '@griply/utils';
import { Goal } from 'shared/types/goal';
import { GoalFormFields } from 'shared/types/goal-form';
import { MetricEntry } from 'shared/types/goal-metric';
import { MetricTemplate } from 'shared/types/metric-template';

export type Options = {
  metricTemplates: MetricTemplate[];
  metricEntries: MetricEntry[] | null;
};

export const mapGoalFieldsToGoal = (
  goalFields: GoalFormFields,
  { metricTemplates, metricEntries }: Options,
): Partial<Goal> | undefined => {
  if (!goalFields.name) {
    return;
  }

  const goal: Partial<Goal> = {
    name: goalFields.name,
    description: goalFields.description ?? null,
    image: goalFields.image ?? null,
    iconName: goalFields.iconName ?? null,
    parentIds: goalFields.parentIds ?? null,
    startDate: goalFields.startDate ?? null,
    deadline: goalFields.deadline ?? null,
    lifeAreaId: goalFields.lifeAreaId ?? null,
    color: goalFields.color ?? null,
    impact: goalFields.impact ?? null,
    metric: null,
  };

  if (goalFields.metricId) {
    const metricTemplate = metricTemplates.find(
      ({ id }) => id === goalFields.metricId,
    );

    if (metricTemplate) {
      goal.metric = buildGoalMetric({
        template: metricTemplate,
        startValue:
          goalFields.metricStartValue != null
            ? String(goalFields.metricStartValue)
            : '',
        targetValue:
          goalFields.metricTargetValue != null
            ? String(goalFields.metricTargetValue)
            : '',
        unitValue: goalFields.metricUnit ?? '',
        entries: metricEntries,
      });
    }
  }

  return goal;
};
